module.exports = __webpack_public_path__ + "img/deferredExchange2.ca91df56.png";